/**
 * Fishermans — Seletor de kit (caixas de quantidade).
 *
 * Raiz propria [data-fm-kit] — NAO usar [data-fm-v2-pdp]: a v2/v3 faz
 * document.querySelector("[data-fm-v2-pdp]") e prende na primeira raiz do DOM.
 *
 * Mesma tecnica aprovada na v3: as caixas nao substituem a logica de variante
 * do tema, elas PILOTAM o controle nativo do Dawn (select ou radio) disparando
 * "change". Assim preco, estoque e submit do form continuam sendo do tema.
 *
 * Enquanto o produto nao tiver a opcao de quantidade cadastrada, nao existe
 * controle nativo pra pilotar: as caixas so mostram o estado selecionado
 * (modo visual, pra aprovar layout).
 */
(function () {
  document.querySelectorAll("[data-fm-kit]").forEach(function (root) {
    var boxes = Array.prototype.slice.call(root.querySelectorAll("[data-fm-kit-box]"));
    if (!boxes.length) return;

    var optRaw = (root.getAttribute("data-fm-kit-option") || "").trim();
    var optName = optRaw.toLowerCase();

    /*
     * Acha o controle nativo do tema pra essa opcao.
     *
     * Casamos pelo atributo name ("options[Quantidade]"), NAO pelo texto do
     * label: o tema tem DOIS elementos rotulados "Quantidade" na mesma pagina
     * — o select da variante e o label do contador -/+ (.product-form__quantity).
     * Texto de label aqui e ambiguo; o name e exato.
     */
    function nativeControl() {
      var scope =
        root.closest("product-info") ||
        root.closest('[id^="shopify-section"]') ||
        document;

      // 1) select da opcao, pelo name exato
      var exact = scope.querySelector('select[name="options[' + optRaw + ']"]');
      if (exact) return { type: "select", el: exact };

      // 2) qualquer select de opcao cujo name contenha o nome da opcao
      var selects = Array.prototype.slice.call(scope.querySelectorAll('select[name^="options["]'));
      for (var i = 0; i < selects.length; i++) {
        if ((selects[i].getAttribute("name") || "").toLowerCase().indexOf(optName) >= 0) {
          return { type: "select", el: selects[i] };
        }
      }

      // 3) pills: radios cujo name contenha o nome da opcao
      var radios = Array.prototype.slice.call(scope.querySelectorAll('input[type=radio][name*="' + optRaw + '"]'));
      if (radios.length) {
        return {
          type: "radio",
          els: radios,
          wrap: radios[0].closest(".product-form__input") || radios[0].parentNode
        };
      }
      return null;
    }

    var native = nativeControl();

    /* Esconde o controle nativo (mas mantem no DOM) — so se ele existir. */
    if (native) {
      var toHide = native.type === "select"
        ? native.el.closest(".product-form__input") || native.el
        : native.wrap;
      if (toHide) toHide.classList.add("fm-kit-hide-native");
    }

    function select(box) {
      boxes.forEach(function (b) {
        var on = b === box;
        b.classList.toggle("is-selected", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
      });

      if (!native) return; // modo visual: nada pra pilotar ainda
      var value = box.getAttribute("data-fm-kit-value");
      if (!value) return;

      if (native.type === "select") {
        var opts = native.el.options;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].value === value || opts[i].text.trim() === value) {
            native.el.selectedIndex = i;
            native.el.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
      } else {
        for (var j = 0; j < native.els.length; j++) {
          if (native.els[j].value === value) {
            native.els[j].checked = true;
            native.els[j].dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
      }
    }

    boxes.forEach(function (box) {
      if (box.hasAttribute("disabled")) return;
      box.addEventListener("click", function () { select(box); });
      box.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") { e.preventDefault(); select(box); }
      });
    });

    /* Estado inicial: o que vier marcado do Liquid (nunca so no JS — regra da v3).
       Se nada vier marcado, cai na primeira caixa disponivel. */
    var pre = root.querySelector("[data-fm-kit-box].is-selected:not([disabled])");
    if (!pre) pre = root.querySelector("[data-fm-kit-box]:not([disabled])");
    if (pre) select(pre);
  });
})();
